// Links to other sites open in a new tab: every <a href> to another origin gets target="_blank"
// rel="noopener noreferrer", including links added or changed later (a MutationObserver), as the
// fullstack's base-layer/app/plugins/externalLinks.client.js does. Not mailto: or tel:, not our
// own fullstack (#register and the like stay in the same tab; CLAUDE.md, Navigation), and not a
// link marked data-same-tab (e.g. the test sites' banner to vizbi.org).

import {getFullstackUrl} from "@/composables/useFullstackUrl";

const SKIPPED_PROTOCOLS = ["mailto:", "tel:"];

function getUrl(link) {
  try {
    return new URL(link.href, window.location.origin);
  } catch {
    return null;
  }
}

function getIsExternal(url) {
  if (!url || SKIPPED_PROTOCOLS.includes(url.protocol)) return false;
  if (url.origin === window.location.origin) return false;
  return url.origin !== new URL(getFullstackUrl(), window.location.origin).origin;
}

function markLink(link) {
  if (link.getAttribute("target") === "_blank" || link.hasAttribute("data-same-tab")) return;
  if (!getIsExternal(getUrl(link))) return;
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener noreferrer");
}

function markLinks(root) {
  if (root?.matches?.("a[href]")) markLink(root);
  root?.querySelectorAll?.("a[href]").forEach(markLink);
}

function observeLinks() {
  markLinks(document.body);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) markLinks(mutation.target);
  });
  const options = {childList: true, subtree: true, attributes: true, attributeFilter: ["href"]};
  observer.observe(document.body, options);
}

export default {
  install() {
    if (typeof window === "undefined") return;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeLinks);
    } else {
      observeLinks();
    }
  }
};
